const $ = require("jquery");
window["$"] = $;
window["jQuery"] = $;

window.Swal = require("sweetalert2");

import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

window.gsap = gsap;
window.ScrollToPlugin = ScrollToPlugin;

require("./dialogs/confirm_dialog");
require("./chat/thirdparty-response");
require("./chat/elevenlabs-streaming");
require("./chat/microsoft-speech-recognition");

$(function () {
    $("#rd-input-text").on("paste", function (event) {
        event.preventDefault();

        // 取得純文字的內容
        let text = (
            event.originalEvent.clipboardData || window.clipboardData
        ).getData("text");

        // 插入純文字到光標位置
        let selection = window.getSelection();
        if (!selection.rangeCount) return;
        selection.deleteFromDocument();

        // 建立 range 並插入純文字
        let range = selection.getRangeAt(0);
        range.insertNode(document.createTextNode(text));

        // 移動光標到插入文字後
        range.setStartAfter(range.endContainer);
        selection.removeAllRanges();
        selection.addRange(range);
    });

    $("#rd-input-text").on("keydown", function (event) {
        if ((event.ctrlKey || event.metaKey) && event.key === "Enter") {
            event.preventDefault();
            sendButtonEvent();
        }
    });

    $("#rd-send-button").on("click", function () {
        sendButtonEvent();
    });

    $(".rd-click-card").on("click", function () {
        stopRecognition();

        let chatId = $('meta[name="chat-id"]').attr("content");
        let question = $(this).data("message");
        let agent_id = $('meta[name="chat-user-id"]').attr("content");
        const audioElement = document.getElementById("audioPlayer");
        audioElement.play();

        $.ajax({
            type: "POST",
            url: $('meta[name="get-card"]').attr("content"),
            data: {
                id: $(this).data("id"),
                chat_id: chatId,
                agent_id: agent_id,
            },
            dataType: "json",
            cache: false,
            success: async function (data) {
                try {
                    setQuestionContent(question);

                    await window.textToSpeech(stripHTML(data.reply));

                    setAnswerContent(data.reply, data.history_id);

                    audioElement.addEventListener(
                        "ended",
                        function () {
                            enableButton();
                            $("#rd-stop-streaming").hide();
                        },
                        { once: true },
                    );

                    $("#rd-stop-streaming").show();
                } catch (err) {
                    console.error(err);
                }
            },
        });
    });

    $("#rd-open-note").on("click", function () {
        if ($(this).hasClass("now")) {
            $(this).removeClass("now");
            $(".did-page").removeClass("open");
        } else {
            $(this).addClass("now");
            $(".did-page").addClass("open");
        }
    });

    $("#rd-new-chat").on("click", function () {
        $.ajax({
            type: "POST",
            url: $('meta[name="new-chat"]').attr("content"),
            dataType: "json",
            cache: false,
            success: function (data) {
                $('meta[name="chat-id"]').attr("content", data.chat_id);
                $('meta[name="third-party-conversation-id"]').attr("content", "");
                window.thirdPartyConversationId = "";
                $("#rd-hello").show();
                $("#rd-card").show();
                $("#msgHistory").html("");
            },
        });
    });

    $("#rd-stop-streaming").on("click", function () {
        const audioElement = document.getElementById("audioPlayer");
        audioElement.pause();
        audioElement.currentTime = 0;
        enableButton();
        $(this).hide();
    });
});

window.disableButton = function () {
    $(".chat-tool").addClass("disable");
    $(".chat-tool").find(".btn-box").hide();
    $("#rd-disable-txt").show();
};

window.enableButton = function () {
    $(".chat-tool").removeClass("disable");
    $(".chat-tool").find(".btn-box").show();
    $("#rd-stop-streaming").hide();
    $("#rd-disable-txt").hide();
};

window.showLoading = function () {
    $("#rd-loading").show();
};

window.hideLoading = function () {
    $("#rd-loading").hide();
};

function sendButtonEvent() {
    stopRecognition();
    disableButton();

    let message = $("#rd-input-text")[0].innerText;
    askOpenAI(message, true, async function (reply, callback) {
        try {
            await window.textToSpeech(reply);

            const audioElement = document.getElementById("audioPlayer");

            await audioElement.play();
            callback();

            audioElement.addEventListener(
                "ended",
                function () {
                    enableButton();
                    $("#rd-stop-streaming").hide();
                },
                { once: true },
            );

            $("#rd-stop-streaming").show();
        } catch (err) {
            console.error(err);
        }
    });
}

function stripHTML(input) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(input, "text/html");
    return doc.body.textContent || "";
}



